<form [formGroup]="questionnaireForm">
  <div class="questionnaire" formArrayName="questionsArray">
    <ng-container
      *ngFor="
        let question of questionnaireForm?.get('questionsArray').controls;
        let i = index
      ">
      <div class="question" [formGroup]="question">
        <h4> {{ questionTopico(i) }} </h4>
        <span> {{ questionDescricao(i) }} </span>
        <div formArrayName="opcoes" class="mt-4">
          <div *ngFor="
              let option of question.get('opcoes').controls;
              let j = index
            " class="mb-3">
            <div class="option" [formGroup]="option">
              <input
                class="d-none"
                type="radio"
                [id]="'q' + i + 'o' + j"
                formControlName="selected"/>
              <div
                class="radio-custom"
                [ngClass]="{ checked: isChecked(option) }"
                [style.opacity]="isEditable ? '1' : '0.5'"
                (click)="markOption(question.get('opcoes'), option)">
              </div>
              <label
                (click)="markOption(question.get('opcoes'), option)">
                {{ questionOptiondescricao(i, j) }}</label>
            </div>
          </div>
        </div>
        <div *ngIf="showScore" class="row mt-3">
          <div class="col-12 col-md-4">
            <label><strong>Pontuação</strong></label>
            <input type="text" class="form-control text-center" [value]="question.get('pontuacao').value" readonly>
          </div>
          <div class="col-12 col-md-4">
            <label><strong>Peso</strong></label>
            <input type="text" class="form-control text-center" [value]="question.get('peso').value" readonly>
          </div>
          <div class="col-12 col-md-4">
            <label><strong>Total de Pontos</strong></label>
            <input type="text" class="form-control text-center text-primary total-pontos-class" [value]="question.get('totalPontos').value" readonly>
          </div>
        </div>
        <hr>
      </div>
    </ng-container>
  </div>
</form>
